import React, { useEffect, useState } from 'react';
import useTheme from '../hooks/useTheme';
import { IComponentHot, IComponentHotOne } from '../../component';
import { alpha } from '../../utils/color';

export default function(props: IComponentHot) {
  const theme = useTheme();
  const { h1Color } = theme;
  const { hot_list } = props;

  const [bigIndex, setBigIndex] = useState(-1 as number);
  const [bigList, setBigList] = useState([] as any[]);

  useEffect(() => {
    setBigList(
      (hot_list || []).map((it: IComponentHotOne, index: number) => {
        return {
          id: index,
          hash: it.image,
          link: it.link
        };
      })
    );
  }, [hot_list]);

  const borderColor = alpha(h1Color, 0.2);
  return {
    setBigIndex,
    borderColor,
    h1Color,
    bigIndex,

    bigList
  };
}
